import React from "react";
import '../css/yoga.css';

const Yoga = () => {
	return (
		<div className="yoga-page">
			<header className="yoga-header">
				<p>
					מקור המילה יוגה הוא בשורש "yog" בשפת סנסקריט(הודית עתיקה), שפירושו: לחבר,לאחד,<br />
					לכוון ולמקד את תשומת הלב וליישם.<br />
					פירוש המילה <span style={{ color: "firebrick", fontWeight: 700 }}>יוגה</span> הוא אחדות - אחדות בין הגוף, הנפש, המחשבה והנשמה.<br />
					התירגול מורכב מאסאנות (תנוחות)  - בעמידה,בישיבה ובשכיבה אשר מובילות ותורמות ליציבות<br />
					פיזית/מנטאלית של הגוף וההכרה וכן לתחושת רווחה כללית.<br />
					הנשימה היא העוגן, השאיפה מובילה את התנועה בהתארכות והנשיפה בהרפיה.<br />
					ככל שמודעים  לסינכרון הנשימה בזמן התירגול,הדבר מסייע למתרגל להתעלות<br />
					מעל חוסר הנוחות הפיזית במקומות מסויימים בגוף,בכך להפחית את המאמץ ולהגיע לנינוחות<br />
					ותחושת שלווה.

					<br />*** במהלך שנים רבות של תירגול - הבנתי שביוגה, התרגול הפיזי משפיע לחיוב בד בבד על הצד המנטאלי-רגשי והרוחני
					דבר הבא לידי ביטוי במערכות היחסים שלנו - עם עצמנו, עם משפחתינו, עם חברינו, עם שכנינו, עם אנשים, שאיתם אנו עובדים/לומדים,<br />
					עם אנשים ששונים מאיתנו, ועם היקום כולו - חי, צומח ודומם.<br />
				</p>
			</header>

			<main className="yoga-main-content">
				<section>
					<h2 id="yoga-subheader">יוגה רכה למבוגרים</h2>
					<p> הגדלת טווח-תנועה,חיזוק והגמשת שרירים,
						סוגי נשימות, דרכים להפחתת חרדות,
						לשינה טובה ולתחושת חיוניות.
						עם הזמן, התרגילים יתמכו בתפקוד היומיומי..</p>
				</section>
				<section>
					<h2 id="yoga-subheader">יוגה בזוגות</h2>
					<p>לתרגל בשניים - (מטפח תקשורת מקרבת, יצירתיות, חוש הומור וכו')
						<span style={{ display: "block", color: "firebrick", fontWeight: 700 }}>דרך תירגול פיזי עדין ומאתגר,</span>
						נאפשר לתמוך ולהיתמך,
						לקבל ולתת
						להקשיב, להשמיע ולהתבוננן פנימה והחוצה -
						חוויה כייפית, שמשאירה טעם של עוד...
					</p>
				</section>
				<section>
					<h2 id="yoga-subheader">בייבי-יוגה ועיסוי תינוקות</h2>
					<p style={{ display: "block", fontWeight: 700 }}>(לאמהות עם תינוקות,שעדיין לא זוחלים)</p>
					<p>
						<span style={{ display: "block", color: "firebrick", fontWeight: 700 }}>מפגש קשב - חוויה רב-חושית</span>
						סדנא של 5 מפגשים בני שעה וחצי, בה
						מוענקים לתינוק/ת ולאם רגעי חום ואהבה,
						דרך תנועה, מגע וצליל.
						עיסוי תינוקות- כלי מדהים לחיבור עם התינוק/ת, משמעותי להתפתחות,
						ולשיחרור גזים, ליחה וכו'..

						דרך שיח והקשבה נוגעות בשאלות, ברגשות ובחששות
						שעולים וצפים אחרי לידה,
						מקבלות כלים, לזמן הכל-כך רגיש והמיוחד.
						מתעצמות ויוצאות מחוייכות ומחוזקות,
					</p>
					<p style={{ color: "firebrick", fontWeight: 700 }}>בידיעה ובאמונה, שכל אמא עושה את הכי טוב שהיא יכולה
						בלהשקות, להאכיל, להאיר, לחמם, ללוות, לתמוך ולתת דוגמא חיובית.</p>

					<p class='yoga-end-p'>
						** ניתן לרכוש שוברי מתנה בהזמנה טלפונית **
					</p>
				</section>

				<br />
			</main>
		</div>
	)
}

export default Yoga